import React from "react"
import { useTranslation } from "react-i18next"
import { Section } from "../Components"
import Slideshow from "../Atoms/Slideshow"
import Colors from "../res/styles/Colors"

function Products() {
    const { t } = useTranslation()
    return (
        <>
            <Section
                bg={Colors.white}
                textColor={Colors.grey}
                body={
                    <>
                        <h3>{t("products.title")}</h3>
                        {t("sections.products.first")}
                    </>
                }
            >
                <Slideshow />
            </Section>
        </>
    )
}

export default Products
